'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('bicycle_parking', {
      url: '/account/parking/bicycle_parking?jurisdiction&sta_recid',
      template: '<bicycle-parking></bicycle-parking>',
      authenticate: true,
      params: {
        jurisdiction: null,
        sta_recid: null      
      }
    });
}



// WEBPACK FOOTER //
// ./client/app/account/parking/bicycle_parking/bicycle_parking.routes.js